import classNames from "classnames";
import { FormSelect, FormTextInput } from "components/form-fields";
import { useValidation } from "hooks/useValidation";
import React, { useEffect } from "react";

export function DocumentTypeDetails({ documentType, onChange, documentAreas, onValidationChange, saving, loading }) {
    const isNew = !documentType.id;
    const isBeingDeleted = !!documentType.dateToBeDeleted;
    
    const [isValid, errors, validate] = useValidation();

    useEffect(() => {
        const rules = [
            { fieldName: "name", required: true, maxLength: 255 },
            { fieldName: "area", required: true }
        ]

        validate(rules, documentType);
    }, [documentType, documentAreas]);

    useEffect(() => onValidationChange(isValid), [isValid]);

    const setName = (name) => {
        const clone = {
            ...documentType,
            name: name
        };

        onChange(clone);
    }

    const setArea = (area) => {
        const clone = {
            ...documentType,
            area: area
        };

        onChange(clone);
    }

    return (
        <div className={classNames({ "row": !isNew })}>
            <h2>Document Details</h2>
            <FormTextInput
                id="document-type-name"
                headingText="Name"
                value={documentType.name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter document name"
                fill={isNew}
                large
                disabled={isBeingDeleted || saving}
                loading={loading}
                dangerHelperText={errors["name"]}
            />
            <FormSelect
                id="document-type-area"
                headingText="Area"
                items={documentAreas.sort((a, b) => a.name.localeCompare(b.name)).filter(a => a.supportsCustomDocumentTypes).map(a => {
                    return {
                        id: a.key,
                        name: a.name
                    }
                })}
                selectedValue={documentType.area}
                onItemSelect={(c) => setArea(c.id)}
                placeholder="Please select"
                dangerHelperText={errors["area"]}
                disabled={isBeingDeleted || saving || !isNew}
                helperText="Once the document area has been set it cannot be changed."
                loading={loading}
            />
        </div>
    );
}